import React from 'react';
import {List, ListItem, Paper} from "@mui/material";
import RoomSummary from "./RoomSummary";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {useSelector} from "react-redux";
import {useAuthUser, useIsAuthenticated} from "react-auth-kit";
import {isDealerSite} from "../../../utils/utils";

const SummaryCosts = () => {
    const rooms = useSelector(state => state.rooms);
    const {selectedRooms} = useSelector(state => state.transactions);
    const portFee = useSelector(state => state.portFee);
    const parkFee = useSelector(state => state.parkFee);

    const tax = useSelector(state => state.tax);
    const totals = useSelector(state => state.totals);
    const auth = useAuthUser();
    const isAuth = useIsAuthenticated();

    const getSpacesByRoom = (roomIndex) => selectedRooms.filter(r => r.index === roomIndex);
    const hasSelectedSpaces = (roomIndex) => getSpacesByRoom(roomIndex).length > 0;
    return (
        <Paper className={'summaryContainer'} elevation={3} style={{marginTop: 20}}>
            <List style={{width: '100%', paddingBottom: 0, paddingTop: 0}}>
                {rooms.map((room) => hasSelectedSpaces(room.index) && <RoomSummary key={room.index} room={room} />)}
                {totals.activitiesAmount > 0 &&
                <ListItem alignItems={"flex-start"} style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                Extra Activities
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                ${(totals.activitiesAmount).formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
                {totals.taxes > 0 &&
                <ListItem alignItems={"flex-start"} style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                Taxes ({tax * 100}%)
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                ${(totals.taxes).formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
                {isDealerSite() && isAuth() && <ListItem alignItems={"flex-start"} style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                Commission ({auth().commission*100}%)
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                ${((totals.total-totals.parkFee)*auth().commission).formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
                {totals.parkFee > 0 &&
                <ListItem alignItems={"flex-start"} style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                {parkFee.description}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                ${(totals.parkFee).formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
                {totals.total > 0 &&
                <ListItem alignItems={"flex-start"}
                          style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                <strong>Total</strong>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                <strong>${(isDealerSite() && isAuth()?totals.total-(totals.total-totals.parkFee)*auth().commission:totals.total).formatMoney(2)}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
                {totals.total > 0 && portFee.feeComment &&
                <ListItem alignItems={"flex-start"}
                          style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                <strong>*{portFee.feeComment}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
            </List>
        </Paper>
    );
};

export default SummaryCosts;
